import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Grid,
	IconButton,
	LinearProgress,
} from '@mui/material';
import { Fragment } from 'react';
import { DialogTitleStyle } from '../assets/theme/Theme';
import { CloseIcon } from '../assets/icons/Icons';

function UserLimitationPopup({
	isOpen,
	count,
	onUpgrade,
	onClose,
	text,
	progress,
}) {
	function handleDlgClose(event, reason) {
		if (reason && reason == 'backdropClick') {
			return;
		}

		onClose();
	}

	return (
		<Dialog
			open={isOpen}
			maxWidth="sm"
			onClose={handleDlgClose}
			PaperProps={{
				sx: {
					position: 'fixed',
					bottom: 0,
					right: 0,
					margin: '16px',
					width: '22%',
					borderRadius: '8px',
				},
			}}
			slotProps={{
				backdrop: {
					invisible: false,
					onClick: event => event.stopPropagation(),
				},
			}}>
			<DialogContent sx={{ paddingBottom: '10px' }}>
				<Grid container sx={{ justifyContent: 'flex-end' }}>
					<IconButton onClick={onClose}>
						<CloseIcon />
					</IconButton>
				</Grid>
				<DialogContentText
					variant="subtitle2"
					style={{
						color: 'rgba(113, 113, 113, 1)',
						fontWeight: 600,
						textAlign: 'center',
						paddingBottom: '5px',
					}}>
					{text}
				</DialogContentText>
				<LinearProgress
					sx={{
						'& .MuiLinearProgress-bar1Determinate': {
							backgroundColor: '#28696D',
						},
						backgroundColor: '#F5F5F5',
						height: 5,
						borderRadius: '10px',
					}}
					variant="determinate"
					value={progress}
				/>
			</DialogContent>
			<DialogActions
				style={{
					justifyContent: 'center',
					marginBottom: '10px',
				}}>
				<Button
					variant="contained"
					style={{
						backgroundColor: '#28696D',
						boxShadow: 'none',
						marginLeft: '10px',
						textTransform: 'none',
					}}
					onClick={onUpgrade}
					autoFocus>
					Upgrade
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default UserLimitationPopup;
